import Input from "../../../../Core/Fields/Floating/Input";
import { useGetDoctypeDetailsQuery } from "../../../../store/api/itemapi";
import { useState } from 'react';

const EditItemModal = ({ show, onClose, itemData, onChange, full_Item_Detail, onSave, fulldata }) => {
  const { data: current_item, isLoading } = useGetDoctypeDetailsQuery({ "doctype": "Item", "name": itemData?.item_code });
  const [currentSerialInput, setCurrentSerialInput] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
console.log("full_Item_Detailfull_Item_Detailfull_Item_Detail",full_Item_Detail,"dsdsdds",fulldata, "sdsdasdsaad",itemData,current_item)
  if (!show || !itemData) return null;

  const handleInput = (e) => {
    const { name, value } = e.target;
    onChange({ ...itemData, [name]: value });
  };

  const handleAddSerial = (e) => {
    if (e.key === 'Enter' || e.type === 'click') {
      e.preventDefault();
      const serialValue = currentSerialInput.trim();

      if (!serialValue) {
        setError("Serial number cannot be empty");
        setSuccess("");
        return;
      }

      const currentSerials = itemData.serial_numbers || [];
      const maxAllowed = Number(full_Item_Detail.accepted_qty) || 0;

      if (currentSerials.includes(serialValue)) {
        setError("This serial number already exists");
        setSuccess("");
        return;
      }

      if (currentSerials.length >= maxAllowed) {
        setError(`You can only add ${maxAllowed} serial numbers for this Item.`);
        setSuccess("");
        return;
      }

      const updatedSerials = [...currentSerials, serialValue];
      onChange({ ...itemData, serial_numbers: updatedSerials });
      setCurrentSerialInput("");
      setError("");
      setSuccess("Serial number added successfully!");
      setTimeout(() => setSuccess(""), 2000);
    }
  };

  const handlePasteSerials = (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData('text/plain');
    const serials = pastedText.split(/[\n,;\t]+/).filter(s => s.trim());

    if (serials.length === 0) return;

    const currentSerials = itemData.serial_numbers || [];
    const maxAllowed = Number(full_Item_Detail.qty) || 0;
    const availableSlots = maxAllowed - currentSerials.length;

    if (serials.length > availableSlots) {
      setError(`You can only add ${availableSlots} more serial numbers.`);
      setSuccess("");
      return;
    }

    const duplicates = serials.filter(s => currentSerials.includes(s));
    if (duplicates.length > 0) {
      setError(`These serial numbers already exist: ${duplicates.join(', ')}`);
      setSuccess("");
      return;
    }

    const newSerials = [...currentSerials, ...serials.slice(0, availableSlots)];
    onChange({ ...itemData, serial_numbers: newSerials });
    setError("");
    setSuccess(`${serials.slice(0, availableSlots).length} serial numbers added successfully!`);
    setTimeout(() => setSuccess(""), 2000);
  };

  const handleRemoveSerial = (index) => {
    const updatedSerials = [...(itemData.serial_numbers || [])];
    const removedSerial = updatedSerials.splice(index, 1);
    onChange({ ...itemData, serial_numbers: updatedSerials });
    setError("");
    setSuccess(`Serial number "${removedSerial}" removed`);
    setTimeout(() => setSuccess(""), 2000);
  };

  const downloadCSV = () => {
    const serials = itemData.serial_numbers || [];
    if (serials.length === 0) return;

    const csvContent = "data:text/csv;charset=utf-8," + serials.map((s, i) => `${i + 1},${s}`).join("\n");
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `serial_numbers_${itemData?.item_code || "item"}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header" style={{ borderBottom: "none" }}>
            <h5 className="modal-title">Edit Item</h5>
            <button type="button" className="btn-close" style={{ width: "5px", height: "5px", paddingLeft: "10px" }} onClick={onClose}></button>
          </div>
          <div className="modal-body">
            {/* Item Info */}
            <div className="row" style={{ marginBottom: '8px' }}>
              <div className="col-6">
                <Input id="date" label="PO No." readOnly value={fulldata?.message?.items?.[0]?.purchase_order} style={{ height: "30px" }} />
              </div>
              <div className="col-6">
                <Input id="Supplier" label="Supplier" value={fulldata?.message?.supplier} style={{ height: "30px" }} readOnly />
              </div>
            </div>

            <div className="row" style={{ marginBottom: '8px' }}>
              <div className="col-6">
                <Input id="Item Name" label="Item Name" value={full_Item_Detail.item_name} style={{ height: "30px" }} readOnly />
              </div>
              <div className="col-6">
                <Input id="Item Code" label="Item Code" value={full_Item_Detail.item_code} style={{ height: "30px" }} readOnly />
              </div>
            </div>

            <div className="row" style={{ marginBottom: '8px' }}>
              <div className="col-6">
                <Input id="Rate" label="Rate" value={full_Item_Detail.rate} style={{ height: "30px" }} readOnly />
              </div>
              <div className="col-6">
                <Input id="UOM" label="UOM" value={full_Item_Detail.uom} style={{ height: "30px" }} readOnly />
              </div>
            </div>

            <div className="row" style={{ marginBottom: '8px' }}>
              <div className="col-6">
                <Input id="Total Qty" label="Total Qty" value={full_Item_Detail.qty} style={{ height: "30px" }} readOnly />
              </div>
              <div className="col-6">
                {console.log("end_of_lifeend_of_life",itemData)}
                <Input type="Expiry Date" id="Expiry Date" label="Expiry Date" value={current_item?.message?.end_of_life || ""} style={{ height: "30px" }} readOnly />
              </div>
            </div>

            {/* Serial Numbers Section */}
            {current_item?.message?.has_serial_no == 1 && (
              <div className="row">
                <div className="col-6">
                 {current_item?.message?.has_batch_no == 1 && current_item?.message?.serial_no_setup != "System Generated" && (  <div className="mb-3" style={{ marginBottom: '25px' }}>
                    <Input
                      id="Batch No."
                      label="Batch No."
                      name="batch_no"
                      value={itemData.batch_no || ""}
                      style={{ height: "30px" }}
                      onChange={handleInput}
                    />
                  </div>)}
                  {current_item?.message?.serial_no_setup == "System Generated" ? '' : <div className="form-floating mb-2">
                    <input
                      type="text"
                      className="form-control p-0 px-2"
                      style={{ height: "30px", fontSize: "0.8rem" }}
                      value={currentSerialInput}
                      onChange={(e) => {
                        setCurrentSerialInput(e.target.value);
                        setError("");
                      }}
                      onKeyPress={handleAddSerial}
                      onPaste={handlePasteSerials}
                      placeholder="Scan serial number"
                    />
                    <label htmlFor="staticInput" className='customBGwhiteBG' style={{ height: "30px", color: "#212529a6", padding: '0.5rem 0.75rem', fontSize: "0.8rem" }}>
                      Scan Serial Numbers
                    </label>
                  </div>}
                  {error && <div className="alert alert-danger py-1 mb-2" style={{ fontSize: '0.8rem' }}>{error}</div>}
                  {success && <div className="alert alert-success py-1 mb-2" style={{ fontSize: '0.8rem' }}>{success}</div>}
                </div>

               {current_item?.message?.serial_no_setup == "System Generated" ? '' : <div className="col-6">
                  
                  <div className="mb-2 position-relative">
                    <label htmlFor="serialNumberBox" className="position-absolute"
                      style={{
                        top: '-10px', left: '12px', backgroundColor: '#ffff',
                        padding: '0 5px', fontSize: '0.75rem', color: '#6c757d', zIndex: 1
                      }}>
                      Scanned Serial Numbers
                    </label>
                    <div
                      id="serialNumberBox"
                      className="form-control"
                      style={{
                        height: '150px',
                        overflowY: 'auto',
                        fontSize: '0.8rem',
                        borderRadius: '10px',
                      }}
                    >
                      <div className="d-flex flex-wrap gap-2">
                        {itemData.serial_numbers?.length > 0 ? (
                          itemData.serial_numbers.map((serial, index) => (
                            <div
                              key={index}
                              className="d-inline-flex align-items-center border"
                              style={{
                                borderRadius: '12px',
                                padding: '4px 8px',
                                fontSize: '0.75rem',
                                lineHeight: '1.2',
                                background: '#EDEDED',
                                maxWidth: '100%',
                                whiteSpace: 'nowrap',
                                marginTop: '5px'
                              }}
                            >
                              <span
                                className="text-truncate"
                                style={{
                                  overflow: 'hidden',
                                  color: 'gray',
                                }}
                              >
                                {index + 1}. {serial}
                              </span>

                              <button
                                onClick={() => handleRemoveSerial(index)}
                                type="button"
                                className="btn btn-sm d-flex justify-content-center align-items-center p-0 ms-2"
                                style={{
                                  width: '13px',
                                  height: '13px',
                                  background: 'white',
                                  border: 'none',
                                  color: 'black',
                                  fontSize: '10px',
                                  borderRadius: '50%',
                                  cursor: 'pointer',
                                }}
                              >
                                ×
                              </button>
                            </div>
                          ))
                        ) : (
                          <div className="text-center text-muted">No serial numbers scanned yet</div>
                        )}
                      </div>
                    </div>

                  </div>
                  {/* Total & Download */}
                  <div className="d-flex justify-content-between align-items-center">
                    <div style={{ fontSize: '0.75rem' }}>
                      Total: {itemData.serial_numbers?.length || 0} serial numbers
                    </div>
                    {itemData.serial_numbers?.length > 0 && (
                      <button className="custom-btn-00989" onClick={downloadCSV} style={{ fontSize: '0.75rem' }}>
                        Download CSV
                      </button>
                    )}

                  </div>

                </div>}
              </div>
            )}
          </div>

          <div className="modal-footer" style={{ borderTop: "none" }}>
            <p style={{ textDecoration: "none", cursor: "pointer" }} className="custom-btn-00989 m-0" onClick={onSave}>
              Save
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditItemModal;
